import axios from "axios";

export const getResultTable = (careersClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/resulttableproperties/" +
        encodeURIComponent(careersClientId)
    )
    .then((res) => res.data);
};

export const editResultTable = (careersClientId, data) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/resulttableproperties/editresulttable/" +
        encodeURIComponent(careersClientId),
      data
    )
    .then((res) => res.data);
};
